import { API_BASE_URL } from '../config';
import api from './axiosInstance';

/* ============================================================
   1) GET PAGINADO DE CONFIGURACIONES
   ============================================================ */
export const getTaskNotificationsPaged = async (
  page = 1,
  pageSize = 10,
  sortBy = null,
  desc = null
) => {
  const res = await api.get(`${API_BASE_URL}/NotificationConfig/list-paged`, {
    params: {
      pageNumber: page,
      pageSize,
      ...(sortBy ? { sortBy } : {}),
      ...(desc !== null && desc !== undefined ? { desc } : {}),
    },
  });
  return res.data;
};

/* ============================================================
   2) GET POR ID (PARA EDICIÓN)
   ============================================================ */
export const getTaskNotificationById = async (id) => {
  const res = await api.get(`${API_BASE_URL}/NotificationConfig/${id}`);
  return res.data;
};

/* ============================================================
   3) CREAR CONFIGURACIÓN
   Backend requiere:
   POST /NotificationConfig/CreateConfiguration
   ============================================================ */
export const createTaskNotification = async (payload) => {
  const res = await api.post(
    `${API_BASE_URL}/NotificationConfig/CreateConfiguration`,
    payload
  );
  return res.data;
};

/* ============================================================
   4) ACTUALIZAR CONFIGURACIÓN
   Backend requiere:
   PUT /NotificationConfig/UpdateConfiguration
   ============================================================ */
export const updateTaskNotification = async (payload) => {
  const res = await api.put(
    `${API_BASE_URL}/NotificationConfig/UpdateConfiguration`,
    payload
  );
  return res.data;
};

/* ============================================================
   5) ELIMINAR CONFIGURACIÓN
   (Si lo implementas, tu backend debe tenerlo)
   ============================================================ */
export const deleteTaskNotification = async (id) => {
  return api.delete(`${API_BASE_URL}/NotificationConfig/Delete/${id}`);
};

/* ============================================================
   6) TEMPLATES DESDE LEGALNEWS
   ============================================================ */
export const getLegalNewsTemplates = async () => {
  const res = await api.get(`${API_BASE_URL}/Messages/Templates`);
  return res.data;
};

/* ============================================================
   7) OBTENER TASK CONFIGURATOR LIST (Tareas)
   ============================================================ */
export const getTaskConfiguratorList = async () => {
  const res = await api.get(`${API_BASE_URL}/Task/GetTaskCode`);
  return res.data;
};

/* ============================================================
   8) OBTENER ÁREAS DE NEGOCIO
   ============================================================ */
export const getBusinessAreas = async () => {
  const res = await api.get(`${API_BASE_URL}/BusinessAreaSaas`, {
    params: { page: 1, pageSize: 500 },
  });

  return res.data.data; // items vienen en "data"
};

/* ============================================================
   9) OBTENER MÉTODOS DE ENVÍO (SendMethod_SAAS)
   ============================================================ */
export const getSendMethods = async () => {
  const res = await api.get(`${API_BASE_URL}/NotificationConfig/sendmethods`);
  return res.data;
};
